export default "__VITE_ASSET__BD5ULwTk__"